import {WriteButton} from '../../common/buttons/WriteActions';
import {ImageUploadStatus} from '../ImageUploadStatus';

import {OrderGuidDto} from '@mybake/ui/models/Order/IOrderGuid';
import {useEffect, useMemo, useState} from 'react';
import {useWorkshopDates} from '../useWorkshopDates';
import {useParams} from 'react-router';
import {
    Alert,
    Box,
    Button,
    Divider,

    Stack,
    TextField,
    Typography
} from '@mui/material';
import {OrderSaveResponse} from './OrderSaveResponse';
import {OrderResponseTemplateDto} from '@mybake/ui/models/Order/IOrderGuid';
import SendIcon from '@mui/icons-material/Send';
import {customerAPI} from '../../../services/CustomerServices';
import {DTO_STATE, IS_DELETED, ORDER_STAGES} from '@mybake/ui/common/dictionary';

import {ICustomer} from '@mybake/ui/models/Customers/ICustomer';
import {IOrder} from '../../../models/Order/IOrder';
import {IPrepayment} from '../../../models/Order/IPrepayment';
import {ISearchString} from '../../../models/ISearchString';
import {ISubOrder} from '../../../models/Order/ISubOrder';
import {orderAPI} from '../../../services/OrderServices';
import {recipeAPI} from '../../../services/RecipeServices';
import CreateSubOrder from './CreateSubOrder';
import MySnackBar from '../../common/snackBars/MySnackBar';
import {OrderValidator} from '../../../validators/OrderValidator';
import {imageAPI} from '../../../services/ImageService';
import {getApiErrorMessage} from '../../../common/apiErrors';
import CreateCustomerNew from '../../customers/CreateCustomerNew';
import {DateObject} from 'react-multi-date-picker';
import {LocalizedDatePicker as DatePicker} from '../../common/dates/LocalizedCalendar';
import TimePicker from 'react-multi-date-picker/plugins/time_picker';
import {packageAPI} from "../../../services/PackageServices";
import {decorationAPI} from "../../../services/DecorationService";
import {productTypesAPI} from '../../../services/ProductTypeServices';
import {useAppTranslation} from "@mybake/ui/hooks/useAppTranslation";
import {ContentSkeleton} from '../../common/loading/ContentSkeleton';
import {useLocation, useNavigate} from "react-router-dom";
import {OrderFormSection} from '../OrderFormSection';
import {CustomerPickerSheet} from '../CustomerPickerSheet';
import {roundMoney} from '../subOrderCost';
import {copyTextToClipboard} from '../../../common/clipboard';
import {useCurrency} from '../../../hooks/useCurrency';
import {toSaveOrderGuidRequest} from '../../../mappers/orderGuid.mapper';
import {IRecipe} from '../../../models/Recipe/IRecipe';
import {IPackage} from '../../../models/Packages/IPackage';
import {IDecoration} from '../../../models/Decorations/IDecoration';
import {IProductType} from '../../../models/ProductTypes/IProductType';
import {ICustomerGuid} from '@mybake/ui/models/Customers/ICustomerGuid';

interface CreateOrderProps {
    handleExistOrderId: (ids: string[]) => void;
    handleCreateOrderMode: () => void;
}

const CreateOrder = () => {
    const workshopDates = useWorkshopDates();
    const {formatCurrency} = useCurrency();
    const {t} = useAppTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const fromHome = Boolean((location.state as {fromHome?: boolean} | null)?.fromHome);

    const {
        data: recipeDtos,
        error: getRecipesError,
        isLoading: getRecipesIsLoading,
        isSuccess: getRecipesIsSuccess
    } = recipeAPI.useGetRecipesForOrderV2Query();
    const {
        data: packageDtos,
        isError: packagesError,
        isLoading: packagesLoading,
        isSuccess: packagesSuccess
    } = packageAPI.useGetPackagesForOrderV2Query();
    const {
        data: decorationDtos,
        isError: decorationsError,
        isLoading: decorationsLoading,
        isSuccess: decorationsSuccess
    } = decorationAPI.useGetDecorationsForOrderV2Query();
    const {data: productTypesV2} = productTypesAPI.useGetProductTypesForOrderV2Query();
    const recipes = useMemo<IRecipe[]>(() => (recipeDtos ?? []).map(recipe => ({
        ...recipe, parts: undefined, recipeDescription: '', isDeleted: IS_DELETED.ACTIVE, state: DTO_STATE.DTO_UNCHANGED, createdAt: null,
        recipeFillings: [], fillings: recipe.fillings.map(filling => ({...filling, fillingDescription: '', isDeleted: IS_DELETED.ACTIVE, state: DTO_STATE.DTO_UNCHANGED, createdAt: null, price: Number(filling.proportionInfos[0]?.cost ?? 0), items: [], recipes: []})),
    })), [recipeDtos]);
    const packages = useMemo<IPackage[]>(() => (packageDtos ?? []).map(value => ({...value, id: value.id ?? '', state: DTO_STATE.DTO_UNCHANGED, productTypes: value.productTypes ?? [], stocks: []})), [packageDtos]);
    const decorations = useMemo<IDecoration[]>(() => (decorationDtos ?? []).map(value => ({...value, id: value.id ?? '', state: DTO_STATE.DTO_UNCHANGED, items: [], priceOptions: value.priceOptions.map(option => ({...option, state: DTO_STATE.DTO_UNCHANGED}))})), [decorationDtos]);
    const productTypes = useMemo<IProductType[]>(() => (productTypesV2 ?? []).map(value => ({...value, packages: [], recipes: [], state: DTO_STATE.DTO_UNCHANGED, priceTiers: value.priceTiers.map(tier => ({...tier, id: tier.id ?? undefined, state: DTO_STATE.DTO_UNCHANGED}))})), [productTypesV2]);
    const [searchCustomers, {
        error: searchError,
        isSuccess: searchIsSuccess
    }] = customerAPI.useSearchCustomersV2Mutation();
    const [saveOrder, {error: saveOrderError}] = orderAPI.useCreateOrderV2Mutation();
    const [expandCreateCustomer, setExpandCreateCustomer] = useState<boolean>(false);
    const [selectedCustomer, setSelectedCustomer] = useState<ICustomer>();
    const [saveOrderSuccessSnackBar, setSaveOrderSuccessSnackBar] = useState<boolean>(false);
    const [saveOrderErrorSnackBar, setSaveOrderErrorSnackBar] = useState<boolean>(false);
    const [copyOrderNumberSnackBar, setCopyOrderNumberSnackBar] = useState<boolean>(false);
    const [disableSaveButton, setDisableSaveButton] = useState<boolean>(false);
    const [inValidOrder, setInValidOrder] = useState(false);
    //const [profit, setProfit] = useState('');

    const [prepaymentInitialState] = useState<IPrepayment>({
        id: -1,
        prepayment: 0,
        state: DTO_STATE.DTO_NEW,
    });
    useParams;
    const [newOrderInitialState] = useState<IOrder>({
        id: crypto.randomUUID(),
        orderNumber: '',
        description: '',
        isDeleted: IS_DELETED.ACTIVE,
        state: DTO_STATE.DTO_NEW,
        price: 0,
        cost: 0,
        customerId: 0,
        subOrders: [],
        stage: ORDER_STAGES.NEW,
        pickUpAt: '',
    });
    const [subOrderInitialState] = useState<ISubOrder[]>([
        {
            id: crypto.randomUUID(),
            recipeName: null,
            recipeId: 0,
            description: '',
            price: 0,
            productCost: 0,
            count: 1,
            recipeCounter: 1,
            orderId: newOrderInitialState.id,
            isDeleted: IS_DELETED.ACTIVE,
            state: DTO_STATE.DTO_NEW,
            images: [],
            decorations: []
        },
    ]);
    const [searchResponse, setSearchResponse] = useState<ICustomer[]>();
    let customersField: string[] = [];
    const [newOrder, setNewOrder] = useState<IOrder>({
        ...newOrderInitialState,
        subOrders: [...subOrderInitialState],
        prepayment: {...prepaymentInitialState}
    });
    const [orderDescription, setOrderDescription] = useState<string>('');
    const [searchPhrase, setSearchPhrase] = useState<string>('');
    let searchAfterAddNewCustomer = '';
    const validator = useMemo(() => OrderValidator.getInstance(newOrder, recipes || []), [newOrder, recipes]);

    const search = () => {
        let timeout: string | number | NodeJS.Timeout | undefined;
        return (e: { target: { value: string } } | null) => {
            const localSearchPhrase: string = e === null ? searchAfterAddNewCustomer : e.target.value;
            searchAfterAddNewCustomer = localSearchPhrase;
            setSearchPhrase(localSearchPhrase);
            const searchString: ISearchString = {search: localSearchPhrase};
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                setSearchResponse(undefined);
                localSearchPhrase.length >= 3 &&
                searchCustomers(searchString).then((result) => {
                    if ('data' in result) {
                        setSearchResponse(result.data as unknown as ICustomer[]);
                        setDialogOpen(true);
                    }
                });
            }, 1000);
        };
    };

    const debounceSearch = useMemo(() => search(), []);
    const processSearchResponse = () => {
        const exInstagram = new RegExp('.*instagram.*');
        const exFacebook = new RegExp('.*facebook.*');
        const exMail = new RegExp('^[\\w\\d.]+@[\\w.]+$');
        const exPhoneNumber = new RegExp('^\\+?\\d+$');
        if (exInstagram.test(searchPhrase)) {
            searchResponse?.map((c) => customersField.push(c.instagram || ''));
            return;
        }
        if (exFacebook.test(searchPhrase)) {
            searchResponse?.map((c) => customersField.push(c.faceBook || ''));
            return;
        }
        if (exMail.test(searchPhrase)) {
            searchResponse?.map((c) => customersField.push(c.email || ''));
            return;
        }
        if (exPhoneNumber.test(searchPhrase)) {
            searchResponse?.map((c) => customersField.push(c.phoneNumber || ''));
            return;
        }
        searchResponse?.map((c) => customersField.push(c.name || ''));
    };

    useMemo(() => processSearchResponse(), [searchResponse]);

    const handelCreateCustomer = () => {
        setExpandCreateCustomer(!expandCreateCustomer);
    };

    const [dialogOpen, setDialogOpen] = useState<boolean>(false);

    const handleCustomerId = (_event: unknown, customer: ICustomer | ICustomerGuid) => {
        const customerId = customer.id;
        if (!customerId) return;
        setNewOrder(prev => ({...prev, customerId}));
        setSelectedCustomer(customer as unknown as ICustomer);
        setDialogOpen(false);
    };

    const setCreatedCustomer = (customer: ICustomer | ICustomerGuid) => {
        const customerId = customer.id;
        if (!customerId) return;
        setNewOrder((prev) => {
            return {
                ...prev,
                customerId,
            };
        });
        setSelectedCustomer(customer as unknown as ICustomer);
    };

    const handleOrderCosts = () => {
        let cost = 0;
        let price = 0;
        newOrder.subOrders?.forEach((element) => {
            cost += element.productCost;
            price += element.price * element.count;
        });

        setNewOrder((prevState) => {
            return {
                ...prevState,
                cost: cost,
                price: price,
            };
        });
    };
    //const [pickUpDate, setPickUpDate] = useState('');
    const handlePickUpDateTime2 = (e: any) => {
        const exDateTime = new RegExp('(?<year>\\d{4})-(?<month>\\d{1,2})-(?<day>\\d{1,2})T(?<hour>\\d{1,2}):(?<min>\\d{1,2})');
        if (exDateTime.test(e.target.value)) {
            setPickUpDate(e.target.value);
            setNewOrder((prev) => {
                return {
                    ...prev,
                    pickUpAt: e.target.value,
                };
            });
        }
    };

    const handlePickUpDateTime = (dateObj: DateObject | null) => {
        if (!dateObj) {
            setPickUpDate(null);
            setNewOrder((prev) => ({...prev, pickUpAt: ''}));
            return;
        }

        setPickUpDate(dateObj);

        // Преобразуем DateObject в строку формата YYYY-MM-DDTHH:mm
        const isoValue = dateObj.format('YYYY-MM-DDTHH:mm');

        setNewOrder((prev) => ({
            ...prev,
            pickUpAt: isoValue,
        }));
    };

    const handleDescription = (e: any) => {
        setOrderDescription(e.target.value);
        setNewOrder((prev) => {
            return {
                ...prev,
                description: e.target.value,
            };
        });
    };

    const handleAddSubOrder = () => {
        setNewOrder((prevState) => {
            return {
                ...prevState,
                subOrders: [
                    ...(prevState.subOrders || []),
                    {
                        id: crypto.randomUUID(),
                        recipeName: null,
                        recipeId: 0,
                        description: '',
                        price: 0,
                        productCost: 0,
                        count: 1,
                        recipeCounter: 1,
                        orderId: newOrderInitialState.id,
                        isDeleted: IS_DELETED.ACTIVE,
                        state: DTO_STATE.DTO_NEW,
                        images: [],
                    },
                ],
            };
        });
    };

    const [newOrderNumber, setNewOrderNumber] = useState('');
    const [responseTemplates, setResponseTemplates] = useState<OrderResponseTemplateDto[]>([]);
    const [savedCheckpoint, setSavedCheckpoint] = useState<OrderGuidDto | null>(null);
    const [saveOrderIsSuccess, setSaveOrderIsSuccess] = useState(false);
    const [saveImages, {error: saveImagesError, isLoading: imagesUploading}] = imageAPI.useUploadImagesV2Mutation();
    const [files, setFiles] = useState<Map<string, File>>(new Map());
    const [pickUpDate, setPickUpDate] = useState<DateObject | null>(null);

    const pickUpDateString = (date: DateObject | null) => (date ? date.format('YYYY-MM-DDTHH:mm') : undefined);

    const handleSaveNewOrder = async () => {
        setDisableSaveButton(true);
        try {
            const saved = savedCheckpoint ?? await saveOrder(toSaveOrderGuidRequest(newOrder)).unwrap();
            setSavedCheckpoint(saved);
            await saveImages({saved, draft: newOrder, files}).unwrap();
            setSaveOrderIsSuccess(true);
            setNewOrderNumber(saved.orderNumber ?? '');
            setResponseTemplates(saved.responseTemplates ?? []);
        } catch {
            setSaveOrderErrorSnackBar(true);
            setDisableSaveButton(false);
        }
    };

    const handleUpdateSubOrders = (subOrder: ISubOrder) => {
        const newSubOrders: ISubOrder[] = [];
        newOrder.subOrders?.forEach((el) => {
            if (el.id !== subOrder.id) newSubOrders.push(el);
            else newSubOrders.push(subOrder);
        });

        const totalCost = roundMoney(newSubOrders.reduce((sum, item) => sum + (Number(item.productCost) || 0), 0));
        const totalPrice = roundMoney(newSubOrders.reduce((sum, item) => sum + (Number(item.price) || 0), 0));

        setNewOrder((prevState) => {
            return {
                ...prevState,
                subOrders: [...newSubOrders],
                cost: totalCost,
                price: totalPrice,
            };
        });
    };

    const handleDeleteSubOrder = (id: string | number) => {
        const subOrder = newOrder.subOrders?.find((el) => el.id === id);
        if (subOrder?.images && subOrder?.images.length > 0) {
            const newMap = new Map(files);
            subOrder.images.forEach((el) => newMap.delete(el.fileName));
            setFiles(newMap);
        }

        const newSubOrders: ISubOrder[] = [];
        newOrder.subOrders?.forEach((el) => {
            if (el.id !== id) newSubOrders.push(el);
        });

        setNewOrder((prevState) => {
            return {
                ...prevState,
                subOrders: [...newSubOrders],
            };
        });
    };

    const buttonStyle = {lineHeight: '1.25rem' /* fontSize: '0.75rem' */};

    const copyOrderNumber = async (text: string) => {
        await copyTextToClipboard(text);
        setCopyOrderNumberSnackBar(true);
    };

    const setFile = (f: File[]) => {
        const filteredFiles = f.filter((file) => {
            return !files.has(file.name);
        });

        const newMap = new Map(files);

        filteredFiles.forEach((file) => {
            newMap.set(file.name, file);
        });

        setFiles(newMap);
    };

    const removeFile = (fileName: string) => {
        setFiles((prevMap) => {
            const newMap = new Map(prevMap);
            newMap.delete(fileName);
            return newMap;
        });
    };

    useEffect(() => {
        if (saveOrderError) setSaveOrderErrorSnackBar(true);
        if (saveOrderIsSuccess && !saveOrderError) setSaveOrderSuccessSnackBar(true);
    }, [saveOrderError, saveOrderIsSuccess]);

    useEffect(() => {
        const isValidOrder = validator.validate(true);
        setInValidOrder(!isValidOrder);
    }, [newOrder, pickUpDate, selectedCustomer]);

    // useEffect(() => {
    //     handleOrderCosts();
    // }, [newOrder.subOrders]);
    //
    // useEffect(() => {
    //     setProfit(Number(newOrder.price - newOrder.cost).toFixed(2));
    // }, [newOrder.price, newOrder.cost]);

    const {cost: totalCost, price: totalPrice} = useMemo(() => {
        if (!newOrder.subOrders?.length) return {cost: 0, price: 0};

        const c = newOrder.subOrders.reduce((sum, sub) => sum + (sub.productCost ?? 0), 0);
        const p = newOrder.subOrders.reduce((sum, sub) => sum + (sub.price), 0);

        return {cost: c, price: p};
    }, [newOrder.subOrders]);

    const profit = useMemo(() => {
        const diff = Number(totalPrice) - Number(totalCost);
        return diff.toFixed(2);
    }, [totalPrice, totalCost]);

    if (getRecipesIsLoading || packagesLoading || decorationsLoading) return <ContentSkeleton variant="form"/>;

    return (
        <Box sx={{width: '100%'}}>
            <Box sx={{paddingBottom: '10px'}}>
                <Stack direction="row" divider={<Divider flexItem/>} alignItems="center" justifyContent={'space-evenly'}
                       gap={'5px'}>
                    <Button variant="outlined" onClick={() => navigate(fromHome ? '/app' : '/app/orders')}
                            sx={buttonStyle}>
                        {fromHome ? t('orders:back_to_home') : t('orders:back_to_orders')}
                    </Button>
                </Stack>
            </Box>
            {saveOrderIsSuccess ? (
                <>
                    <MySnackBar
                        duration={5000}
                        openSnackBar={saveOrderSuccessSnackBar}
                        handleClose={() => setSaveOrderSuccessSnackBar(false)}
                        severity={'success'}
                        alertText={t('orders:order_created_success')}
                    />
                    <OrderSaveResponse orderNumber={newOrderNumber} responseTemplates={responseTemplates} onCopy={copyOrderNumber}/>
                </>
            ) : (
                <Box sx={{width: '100%'}}>
                    <Stack spacing={2}>
                        {savedCheckpoint && !saveOrderIsSuccess && <ImageUploadStatus orderId={savedCheckpoint.id} uploading={imagesUploading} created/>}
                        <Box component="fieldset" disabled={Boolean(savedCheckpoint)} sx={{border: 0, p: 0, m: 0, minWidth: 0, display: imagesUploading ? 'none' : undefined}}>
                        <Stack spacing={2}>
                        <OrderFormSection title={t('orders:order_description')}>
                            <TextField
                                fullWidth
                                id="description"
                                label={t('orders:order_description')}
                                value={orderDescription}
                                multiline
                                minRows={3}
                                onChange={handleDescription}
                            />
                        </OrderFormSection>

                        <OrderFormSection title={t('customers:customer')}>
                            <Stack spacing={1.25}>
                                <TextField
                                    required
                                    fullWidth
                                    id="searchPhrase"
                                    label={t('customers:search_customer')}
                                    placeholder={t('customers:search_customer')}
                                    value={searchPhrase}
                                    onChange={debounceSearch}
                                    helperText={searchPhrase && searchPhrase.length < 3 ? t('customers:search_customer') : undefined}
                                    error={Boolean(searchPhrase) && searchPhrase.length < 3}
                                />
                                {searchResponse && (
                                    <Button variant="outlined" onClick={() => setDialogOpen(true)} sx={{alignSelf: 'flex-start'}}>
                                        {t('customers:found_customers')}
                                    </Button>
                                )}
                                <Box sx={{p: 1.25, borderRadius: 2, bgcolor: selectedCustomer ? 'action.hover' : 'rgba(211, 47, 47, 0.08)'}}>
                                    <Typography variant="caption" color="text.secondary">{t('customers:selected_customer')}</Typography>
                                    <Typography fontWeight={700}>{selectedCustomer?.name || selectedCustomer?.phoneNumber || selectedCustomer?.email || t('customers:no_customer')}</Typography>
                                </Box>
                                {searchError && (
                                    <Stack spacing={1} alignItems="flex-start">
                                        <Typography color="text.secondary">{t('customers:customer_not_found')}</Typography>
                                        <WriteButton variant="outlined" onClick={handelCreateCustomer}>{t('customers:create_customer')}</WriteButton>
                                        {expandCreateCustomer && (
                                            <CreateCustomerNew handleCreateCustomerDialog={handelCreateCustomer}
                                                               setCreatedCustomer={setCreatedCustomer}
                                                               initValue={searchPhrase}/>
                                        )}
                                    </Stack>
                                )}
                            </Stack>
                        </OrderFormSection>

                        <CustomerPickerSheet
                            open={dialogOpen}
                            customers={searchResponse}
                            selectedCustomerId={newOrder.customerId}
                            isLoading={!searchIsSuccess && !searchResponse}
                            onClose={() => setDialogOpen(false)}
                            onSelect={customer => handleCustomerId(null, customer)}
                        />

                        <OrderFormSection
                            title={t('orders:sub_orders')}
                            action={<WriteButton size="small" variant="contained" onClick={handleAddSubOrder}>{t('orders:add_suborder')}</WriteButton>}
                        >
                            <Stack spacing={1.25}>
                                {newOrder.subOrders?.map((s) => (
                                    <CreateSubOrder
                                        key={s.id}
                                        setFile={setFile}
                                        removeFile={removeFile}
                                        subOrder={s}
                                        recipes={recipes}
                                        packages={packages}
                                        decorations={decorations}
                                        productTypes={productTypes}
                                        handleUpdateSubOrders={handleUpdateSubOrders}
                                        deleteSubOrder={handleDeleteSubOrder}
                                    />
                                ))}
                            </Stack>
                        </OrderFormSection>
                    {/*                    <Box style={{ paddingTop: 10 }}>
                        <TextField
                            style={{ marginBottom: 10 }}
                            required
                            id={'pickUpDate'}
                            label={getTitle(language, FIELDS.ORDERS.PICK_UP_DATE)}
                            type="datetime-local"
                            placeholder={getTitle(language, FIELDS.ORDERS.PICK_UP_DATE)}
                            onChange={handlePickUpDateTime}
                            onClick={handlePickUpDateTime}
                            color={!pickUpDate ? 'error' : 'success'}
                            focused
                        />
                    </Box>*/}

                        <OrderFormSection title={t('dates:pick_up_date')}>
                        <Typography
                            sx={{mb: 0.75, fontWeight: 500, color: !pickUpDate ? 'error.main' : 'text.primary'}}
                        >
                            {t('dates:pick_up_date')} *
                        </Typography>

                        <DatePicker
                            workshopDates={workshopDates}
                            showHolidayLegend
                            value={pickUpDate || undefined}
                            onChange={(value) => {
                                const dateObj = Array.isArray(value) ? value[0] : value;
                                handlePickUpDateTime(dateObj instanceof DateObject ? dateObj : null);
                            }}
                            format="YYYY-MM-DD HH:mm"
                            type="datetime" // обязательно для выбора даты и времени
                            plugins={[<TimePicker position="bottom"/>]}
                            weekStartDayIndex={1}
                            style={{
                                width: '100%',
                                marginBottom: 10,
                                padding: '12px',
                                borderRadius: 6,
                                border: !pickUpDate ? '1px solid #d32f2f' : '1px solid #4caf50',
                                outline: 'none',
                            }}
                            calendarPosition="bottom-center"
                        />
                        </OrderFormSection>
                        <OrderFormSection title={t('finance:total_order_price')}>
                            <Box sx={{display: 'grid', gridTemplateColumns: {xs: '1fr', sm: 'repeat(3, 1fr)'}, gap: 1.5}}>
                                <Box><Typography variant="caption" color="text.secondary">{t('finance:total_order_price')}</Typography><Typography fontWeight={700}>{formatCurrency(totalPrice)}</Typography></Box>
                                <Box><Typography variant="caption" color="text.secondary">{t('finance:total_order_cost')}</Typography><Typography fontWeight={700}>{formatCurrency(totalCost)}</Typography></Box>
                                <Box><Typography variant="caption" color="text.secondary">{t('finance:total_order_profit')}</Typography><Typography fontWeight={700}>{formatCurrency(profit)}</Typography></Box>
                            </Box>
                        </OrderFormSection>
                        </Stack>
                        </Box>
                        <WriteButton
                            disabled={inValidOrder || disableSaveButton}
                            variant="contained"
                            fullWidth
                            onClick={handleSaveNewOrder}
                            sx={{display: imagesUploading ? 'none' : undefined}}
                            endIcon={<SendIcon/>}
                        >
                            {t('common:save')}
                        </WriteButton>
                    </Stack>
                </Box>
            )}
            <MySnackBar
                duration={5000}
                openSnackBar={saveOrderErrorSnackBar}
                handleClose={() => setSaveOrderErrorSnackBar(false)}
                severity={'error'}
                alertText={saveOrderError ? getApiErrorMessage(saveOrderError, t) : t('common:server_error')}
            />
            {saveImagesError && <Alert severity="error">{getApiErrorMessage(saveImagesError, t)}</Alert>}
            <MySnackBar
                duration={5000}
                openSnackBar={copyOrderNumberSnackBar}
                handleClose={() => setCopyOrderNumberSnackBar(false)}
                severity={'success'}
                alertText="The order number is copied!"
            />
        </Box>
    );
};

export default CreateOrder;
